<!DOCTYPE html>
<html lang="en" *ngIf="route.children.length === 0">

<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1">

</head>

<body>
  <div class="container white_bg body_min_height">
    <div class="PageTitle">
      <h3 id="title" style="text-align: center;"><b>National Setup</b></h3>
    </div>

    <ng-container *ngIf="!lockDown; else lockDownMode">
      <div class="container row flexbox-left" style="text-align:center; padding-left: 96px">
        <a *ngIf="permissionHandlingService.npaRead" (click)="navigateTo('national package template')"
          (click)="logNavigation('nationalPackageTemplate')"
          class="col-md-1 sm-link sm-link_padding-all sm-link1 styled-links"
          style="white-space:nowrap; display: inline-block; width: 300px; cursor: pointer; pointer-events: none; color: grey;">
          <h4 class="sm-link__label"><b>National Package Template</b></h4>
        </a>

        <div class="divider"></div>

        <a *ngIf="permissionHandlingService.ndiRead" (click)="navigateTo('national dispatch template')" 
                  (click)="logNavigation('nationalDispatchTemplate')"
          class="col-md-1 sm-link sm-link_padding-all sm-link1 styled-links"
          style="white-space:nowrap; display: inline-block; width: 300px; cursor: pointer;">
          <h4 class="sm-link__label"><b>National Dispatch Template</b></h4>
        </a>

        <div class="divider"></div>

        <a *ngIf="permissionHandlingService.ncsRead" (click)="navigateTo('national corp setup')" 
          (click)="logNavigation('nationalCorpSetup')"
          class="col-md-1 sm-link sm-link_padding-all sm-link1 styled-links"
          style="white-space:nowrap; display: inline-block; width: 300px; cursor: pointer;">
          <h4 class="sm-link__label"><b>National Corp Setup</b></h4>
        </a>
      </div>
    </ng-container>

    <ng-template #lockDownMode>
      <H1 class="col-md-12 flexbox-center no-wrapping" style="text-align:left;">{{ bannerMessage }}</H1>
      <H1 class="col-md-1 col-md-offset-6 flexbox-center no-wrapping" *ngIf="lockdownMsg">EFS Systems will be available October 19th</H1>
      <H1 class="col-md-1 col-md-offset-3 flexbox-center no-wrapping" *ngIf="ieMessage">Please log in through Chrome/Firefox Browser</H1>
    </ng-template>


  </div>
</body>
</html>
<router-outlet></router-outlet>
